export const formatTimeRemaining = (expiresAt: string): string => {
  try {
    const expirationDate = new Date(expiresAt);
    const now = new Date();
    
    const diffMs = expirationDate.getTime() - now.getTime();
    
    if (diffMs <= 0) {
      return '0h';
    }
    
    const totalMinutes = Math.floor(diffMs / (1000 * 60));
    
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    
    if (minutes === 0) {
      return `${hours}h`;
    }
    
    return `${hours}h:${minutes}min`;
  } catch (error) {
    return '';
  }
};

export default formatTimeRemaining;
